import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {PageViewCreateRequest, PageViewCreateResponse} from './contracts'

export async function apiCreateView(body: PageViewCreateRequest): Promise<PageViewCreateResponse> {
  const apiData = getApiMetadata('memex-view-create-api-data')

  const {data} = await fetchJSON<PageViewCreateRequest, PageViewCreateResponse>(apiData.url, {
    method: 'POST',
    body,
    token: apiData.token,
  })

  return data
}
